import { render, staticRenderFns } from "./MatchList.vue?vue&type=template&id=1642cfc3&scoped=true&"
import script from "./MatchList.vue?vue&type=script&lang=js&"
export * from "./MatchList.vue?vue&type=script&lang=js&"
import style0 from "@/sass/08_modules/match-list.scss?vue&type=style&index=0&id=1642cfc3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1642cfc3",
  null
  
)

export default component.exports